import { API_URL } from "./config";
import axios from "axios";

const PROJECTS_URL = `${API_URL}/projects`;

export interface ProjectsModel {
  name: string;
  advertiser: string;
  id?: string;
  total_analysis: string;
}
interface listAnalysesParams {
  sortingColumns: any;
  page?: number;
  pageSize?: number;
}

export const listProjects = async (
  {
    sortingColumns = {},
    page = 1,
    pageSize = 2000,
  }: listAnalysesParams
): Promise<any> => {
  const ordering = [];
  for (const [key, value] of Object.entries(sortingColumns)) {
    if (value === "asc" || value === "desc") {
      ordering.push(`${value === "asc" ? "" : "-"}${key}`);
    }
  }
  const params: any = {
    page: page.toString(),
    page_size: pageSize.toString(),
  };
  if (ordering.length > 0) {
    params["ordering"] = ordering.join(",");
  } else {
    params["ordering"] = "-created_at";
  }
  const response = await axios
    .get(PROJECTS_URL, { params })
    .catch((error) => {
      console.error("Error list projects", error);
      throw error;
    });

  return response.data;
};

export const getProject = async (projectId: string): Promise<ProjectsModel> => {
  const response = await axios
    .get(`${PROJECTS_URL}/${projectId}`)
    .catch((error) => {
      console.error("Error fetching projects by ID:", error);
      throw error;
    });

  return response.data;
};

export const createProject = async (project: {
  advertiser: string;
  name: string;
}): Promise<any> => {
  const response = await axios
    .post(`${PROJECTS_URL}/create`, project)
    .catch((error) => {
      console.error("Error creating project:", error);
      throw error;
    });

  return response.data;
};

export const patchProject = async (
  projectId: string,
  config: ProjectsModel
): Promise<any> => {
  const response = await axios
    .patch(`${PROJECTS_URL}/${projectId}`, config)
    .catch((error) => {
      console.error("Error patching project:", error);
      throw error;
    });

  return response.data;
};

export const deleteProject = async (projectId: string) => {
  const response = await axios
    .delete(`${PROJECTS_URL}/${projectId}`)
    .catch((error) => {
      console.error("Error deleting project:", error);
      throw error;
    });

  return response.data;
};
